export const TRANSLATIONS = {
    // 결제 페이지 (PaymentPage) 전용 키
    paymentTitle: { Ko: '주문/결제', En: 'Checkout', Ja: '注文/決済', Zh: '订单/支付' }, // title -> paymentTitle로 변경
    orderList: { Ko: '주문 상품 내역', En: 'Order Summary', Ja: '注文商品内訳', Zh: '订单商品详情' },
    quantity: { Ko: '수량', En: 'Qty', Ja: '数量', Zh: '数量' },
    unit: { Ko: '개', En: 'ea', Ja: '個', Zh: '个' },
    amountLabel: { Ko: '결제금액', En: 'Total Amount', Ja: '決済金額', Zh: '支付金额' },
    paymentMethod: { Ko: '결제 수단 선택', En: 'Payment Method', Ja: '決済手段選択', Zh: '选择支付方式' },
    creditCard: { Ko: '신용/체크카드', En: 'Credit/Debit Card', Ja: 'クレジットカード', Zh: '信用卡/借记卡' },
    easyPay: { Ko: '간편결제', En: 'Easy Pay', Ja: '簡易決済', Zh: '便捷支付' },
    payBtn: { Ko: '결제하기', En: 'Pay Now', Ja: '決済する', Zh: '立即支付' },
    noInfo: { Ko: '결제 정보가 없습니다.', En: 'No payment info.', Ja: '決済情報がありません。', Zh: '没有支付信息。' },
    confirm: { Ko: '확인', En: 'Confirm', Ja: '確認', Zh: '确认' }, // 누락되었던 키 추가
    currency: { Ko: '원', En: 'KRW', Ja: 'ウォン', Zh: '韩元' },

    // 알림 메시지
    alertSuccess: { Ko: '결제가 완료되었습니다.', En: 'Payment completed.', Ja: '決済が完了しました。', Zh: '支付已完成。' },
    alertProcess: {
        card: { Ko: '신용카드 결제를 진행합니다.', En: 'Processing Credit Card...', Ja: 'クレジットカード決済を進行します。', Zh: '正在进行信用卡支付。' },
        easy: { Ko: '간편결제를 진행합니다.', En: 'Processing Easy Pay...', Ja: '簡易決済を進行합니다.', Zh: '正在进行便捷支付。' }
    },

    // 메인 및 기타 페이지용
    all: { Ko: '전체', En: 'All', Ja: 'すべて', Zh: '全部' },
    support: { Ko: '고객센터', En: 'Support', Ja: 'サポート', Zh: '客服' },
    cart: { Ko: '장바구니', En: 'Cart', Ja: 'カート', Zh: '购物车' },
    soldOut: { Ko: '품절', En: 'Sold Out', Ja: '売り切れ', Zh: '已售罄' },
    noProducts: { Ko: '등록된 상품이 없습니다.', En: 'No products available.', Ja: '商品가 없습니다.', Zh: '没有商品。' },
    detailInfo: { Ko: '상세 정보', En: 'Details', Ja: '詳細情報', Zh: '详情' },
    noDetailImg: { Ko: '상세 이미지가 없습니다.', En: 'No detail image.', Ja: '詳細画像がありません。', Zh: '没有详情图。' },
    cancel: { Ko: '취소', En: 'Cancel', Ja: 'キャンセル', Zh: '取消' },
    add: { Ko: '담기', En: 'Add', Ja: '入れる', Zh: '加入' },
    emptyCart: { Ko: '장바구니가 비어있습니다.', En: 'Cart is empty.', Ja: 'カートが空です.', Zh: '购物车是空的。' },
    totalAmount: { Ko: '총 결제금액', En: 'Total', Ja: '合計金額', Zh: '总金额' },
    checkout: { Ko: '결제하기', En: 'Checkout', Ja: '決済する', Zh: '支付' },
    bizInfo: { Ko: '사업자 정보', En: 'Business Info', Ja: '事業者情報', Zh: '商家信息' },
    viewCart: { Ko: '장바구니 보기', En: 'View Cart', Ja: 'カートを見る', Zh: '查看购物车' },
    naverPay: { Ko: '네이버페이', En: 'Naver Pay' },
    kakaoPay: { Ko: '카카오페이', En: 'Kakao Pay' },
    processing: { Ko: '처리 중...', En: 'Processing...' },

    // 결제 완료 페이지 (PaymentSuccessPage)
    successTitle:   { Ko: '결제 완료', En: 'Payment Complete', Ja: '決済完了', Zh: '支付完成' },
    successMessage: { Ko: '결제가 완료되었습니다.', En: 'Your payment was successful.', Ja: '決済が完了しました。', Zh: '支付已成功完成。' },
    orderAgain:     { Ko: '다시 주문하기', En: 'Order Again', Ja: 'もう一度注文する', Zh: '再次订购' },
};